module.exports = __webpack_public_path__ + "static/media/radiografia.3499ca72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empresa/radiografia.svg
// module id = 155
// module chunks = 0